// API client for database backend endpoints
const API_URL = import.meta.env.PROD ? '/api' : 'http://localhost:3003/api';

// Hero Slides API
export interface HeroSlide {
  id: number;
  image: string;
  title: string;
  subtitle?: string;
  order_index: number;
  active: number;
  created_at?: string;
  updated_at?: string;
}

export const heroSlidesAPI = {
  getAll: async (): Promise<HeroSlide[]> => {
    const response = await fetch(`${API_URL}/hero-slides`);
    if (!response.ok) throw new Error('Failed to fetch hero slides');
    return response.json();
  },

  create: async (slide: Omit<HeroSlide, 'id' | 'created_at' | 'updated_at' | 'active'>): Promise<{ success: boolean; id: number }> => {
    const response = await fetch(`${API_URL}/hero-slides`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(slide),
    });
    if (!response.ok) throw new Error('Failed to create hero slide');
    return response.json();
  },

  update: async (id: number, updates: Partial<HeroSlide>): Promise<{ success: boolean }> => {
    const response = await fetch(`${API_URL}/hero-slides/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Failed to update hero slide');
    return response.json();
  },

  delete: async (id: number): Promise<{ success: boolean }> => {
    const response = await fetch(`${API_URL}/hero-slides/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete hero slide');
    return response.json();
  },
};

// Gallery Images API
export interface GalleryImage {
  id: number;
  image: string;
  alt_text?: string;
  order_index: number;
  active: number;
  created_at?: string;
  updated_at?: string;
}

export const galleryImagesAPI = {
  getAll: async (): Promise<GalleryImage[]> => {
    const response = await fetch(`${API_URL}/gallery-images`);
    if (!response.ok) throw new Error('Failed to fetch gallery images');
    return response.json();
  },

  create: async (image: Omit<GalleryImage, 'id' | 'created_at' | 'updated_at' | 'active'>): Promise<{ success: boolean; id: number }> => {
    const response = await fetch(`${API_URL}/gallery-images`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(image),
    });
    if (!response.ok) throw new Error('Failed to create gallery image');
    return response.json();
  },

  update: async (id: number, updates: Partial<GalleryImage>): Promise<{ success: boolean }> => {
    const response = await fetch(`${API_URL}/gallery-images/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!response.ok) throw new Error('Failed to update gallery image');
    return response.json();
  },

  delete: async (id: number): Promise<{ success: boolean }> => {
    const response = await fetch(`${API_URL}/gallery-images/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete gallery image');
    return response.json();
  },
};
